<template>
    <div>
      <!-- Dynamically render the form component based on the note type -->
      <component :is="formComponent" :unitDetails="unitDetails"></component>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import EditUnitDetails from './EditUnitDetails.vue'; // Example of a form component for a specific type
  // Import other form components
  
  export default {
    components: {
      EditUnitDetails,
      // Register other form components here
    },
    data() {
      return {
        unitDetails: "",
      };
    },
    computed: {
      formComponent() {
        return 'EditUnitDetails';
      },
    },
  async mounted() {
    const permissions = this.getPermissions();
    const hasAccess =
      permissions.includes("maintenance.view_unit") ||
      permissions.includes("access_control.maintenance.view_unit") ||
      permissions.includes("ui_access_units_view") ||
      permissions.includes("access_control.ui_access_units_view");
    if (!hasAccess) {
      this.$router.push({ name: "MainPanel" });
      return;
    }
    await this.fetchUnitProfileDetails();
  },
    methods: {
    getPermissions() {
      try {
        return JSON.parse(localStorage.getItem("userPermissions")) || [];
      } catch (error) {
        return [];
      }
    },
      async fetchUnitProfileDetails() {
        const unit_id = this.$route.params.unit_id;
        console.log(unit_id)
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/unit_detail/` + unit_id + "/");
          this.unitDetails = response.data;
        } catch (error) {
          console.error("Failed to fetch unit details:", error);
          // Handle error (e.g., show user feedback)
        }
      }
    }
  };
  </script>